define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "ลงทะเบียนผู้ใช้อีกคน",

    'incrowd_stats.num_responders': "{{num}} ผู้เชี่ยวชาญมืออาชีพด้านการดูแลสุขภาพ",
    'incrowd_stats.num_answers': "{{num}} คำถามที่ตอบแล้ว",
    'incrowd_stats.time_to_complete': "{{num}} นาทีเพื่อทำการสำรวจโดยเฉลี่ยให้เสร็จสิ้น ",

    // INCROWD
    'incrowd.about': "เกี่ยวกับ",
    'incrowd.contact': "ติดต่อ",
    'incrowd.press': "กด",
    'incrowd.careers': "อาชีพ",
    'incrowd.terms': "ข้อกำหนด",
    'incrowd.t_and_c': "ข้อกำหนดและเงื่อนไข",
    'incrowd.faq': "คำถามที่พบบ่อย",
    'incrowd.privacy': "ความเป็นส่วนตัว",
    'incrowd.copyright': "{{year}} InCrowd Inc, ขอสงวนลิขสิทธิ์",
    'incrowd.blog': "บล็อก",
    'incrowd.support': "ฝ่ายสนับสนุน",
    'incrowd.info.ios': "คุณทราบหรือไม่ว่าตอนนี้ทีมแพทย์ในเครือข่ายของ InCrowd สามารถส่งคำถามไปยังเพื่อนร่วมงานของพวกเขาได้โดยตรงแล้ว? ลองใช้ <แอป InCrowd สำหรับ iOS> ตอนนี้!",
    'incrowd.refer': "ชอบทำแบบสำรวจของเราไหม? <อ้างอิงเพื่อน> วันนี้เพื่อเข้าร่วมคราวด์ของเราและคุณทั้งสองจะได้รับ 10 ดอลลาร์สหรัฐฯ (หรือเทียบเท่า) เมื่อเพื่อนร่วมงานของคุณตอบแบบสำรวจ พวกเขาจะได้รับโบนัส!",


    // GET STARTED (step 0)
    'getstarted.encourage.title': "แบบสำรวจสั้น ๆ",
    'getstarted.encourage.title.two': "ผลกระทบอันยิ่งใหญ่",
    'getstarted.encourage.subtitle': "เข้าร่วมกับผู้เชี่ยวชาญด้านการแพทย์ที่มีคุณวุฒิหลายพันคนในการส่งผลกระทบต่อการพัฒนาผลิตภัณฑ์และการรักษาผู้ป่วยใหม่ผ่านแบบสำรวจสั้น ๆ ง่าย ๆ และเราจ่ายเงินให้คุณด้วย!",
    'getstarted.encourage.redirect_to_solutions': "ไม่ใช่ผู้เชี่ยวชาญทางด้านสาธารณสุขแต่ต้องการเรียนรู้เพิ่มเติมเกี่ยวกับ InCrowd?",
    'getstarted.actions.title': "คุณเป็นผู้เชี่ยวชาญด้านการแพทย์ที่มีคุณวุฒิหรือไม่?",
    'getstarted.actions.subtitle': "สมัครสมาชิกวันนี้และเริ่มหาเงินโดยการตอบแบบสำรวจสั้น ๆ ที่มุ่งเป้าไปทางการดูแลสุขภาพ",
    'getstarted.button.continue': "เริ่ม",
    'getstarted.referral': "สมัครเพื่อรับเงินจากการทำแบบสำรวจรวมถึงโบนัสการอ้างอิงของคุณจาก %{{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "เราต้องการรายละเอียดสองสามอย่างจากคุณเพื่อตั้งค่าบัญชีของคุณ",
    'details.profile_details': "รายละเอียดโปรไฟล์",
    'details.address_information': "ข้อมูลที่อยู่",
    'details.professional_info': "ข้อมูลวิชาชีพ",
    'details.heading.finally': "…และท้ายที่สุด",
    'details.how_receive_surveys': "คุณประสงค์จะรับแบบสำรวจในทางใด?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "ข้อมูลเบื้องต้น",
    'professionchoice.encourage.subtitle': "ไม่เห็นอาชีพของคุณ? บอกให้เราทราบ <ที่นี่> เพื่อให้แน่ใจว่าคุณจะได้รับแจ้งเตือนเมื่อเราเพิ่มอาชีพของคุณ",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "คุณเป็นใคร?",
    'authentication.encourage.subtitle': "InCrowd ต้องการยืนยันตัวตนของคุณ แต่เราจะไม่เปิดเผยหรือเผยแพร่ข้อมูลส่วนตัวของคุณให้กับบุคคลที่สามแต่อย่างใด",
    'authentication.actions.select_notifications': "เลือกว่าคุณต้องการรับแบบสอบถามจากเราอย่างไร",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "โปรดรอขณะที่เรายืนยันความถูกต้องของข้อมูลของคุณ",
    'validation.please_answer': "โปรดตอบคำถามต่อไปนี้เพื่อช่วยให้เรายืนยันความถูกต้องของรายละเอียดส่วนตัวของคุณ",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "การยืนยัน",
    'confirmation.validation_success.subtitle': "การลงทะเบียนของคุณเรียบร้อยแล้ว ยินดีต้อนรับสู่ InCrowd! คุณจะได้รับการยืนยันในไม่ช้าผ่านทางอีเมลและ/หรือข้อความตัวอักษร ขอบคุณสำหรับการเข้าร่วม!",
    'confirmation.validation_error.title': "ต้องการข้อมูลเพิ่มเติม",
    'confirmation.validation_error.subtitle': "ขออภัย, %{userFirstName}, มีปัญหาเกี่ยวกับการยืนยันความถูกต้องของรายละเอียดส่วนตัวของคุณ",
    'confirmation.actions_title': "มีอะไรต่อไป?",
    'confirmation.go_to_your_profile': "ไปที่โปรไฟล์ของคุณ",
    'confirmation.validation_success.actions_subtitle': "คุณจะเริ่มรับการสำรวจแบบจุลภาคระยะเวลา 3 - 5 นาทีของเราในอีกสองสามวันผ่านทางอีเมลหรือข้อความตัวอักษร ยังไม่ได้เข้าร่วมการรับการสำรวจผ่านทางข้อความตัวอักษร? คุณสามารถเปลี่ยนการตั้งค่าการสื่อสารของคุณได้ตลอดเวลาจากโปรไฟล์ InCrowd ของคุณ",
    'confirmation.validation_error.actions_subtitle': "โปรดใช้ป๊อปอัปแชทตรงด้านล่างขวามือของหน้าจอเพื่อพูดคุยกับสมาชิกในทีม InCrowd และระบุปัญหาที่ยังค้างอยู่ทั้งหมด",
    'confirmation.referral.info.1': "ภายใน %{payoutBusinessDays} วันทำการหลังจากที่ทำแบบสำรวจที่ 2 เสร็จ คุณและบุคคลที่อ้างอิงถึงคุณ <จะได้รับคนละ %{currency}%{referralBonusAmount}> จะมีการเพิ่ม %{currency}%{referralBonusAmount} ไปยังบัญชีรางวัลของคุณ คุณสามารถเข้าสู่ <โปรไฟล์> ของคุณได้ตลอดเวลาเพื่ออัปเดตการกำหนดค่าของคุณ ตรวจสอบรางวัลของคุณ หรือเข้าถึงแบบสำรวจเปิดใด ๆ ที่คุณได้รับเชิญ",
    'confirmation.referral.info.2': "มีคำถาม? <แชทกับเรา>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "คุณมีคุณสมบัติเหมาะสมหรือไม่?",
    'regftr.markets.accepting': "InCrowd Answers ตอนนี้กำลังรับ:",
    'regftr.peers.title': "เพื่อน",
    'regftr.peers.subtitle': "เปรียบเทียบคำตอบของคุณกับคำตอบของเพื่อน ๆ และเรียนรู้จากคำตอบของพวกเขา",
    'regftr.invites.title': "คำเชิญ",
    'regftr.invites.subtitle': "รับคำเชิญเข้าร่วมแบบสอบถามใหม่ผ่านทางอีเมลหรือบนโทรศัพท์ของคุณเพื่อทำรายได้ของคุณให้มากที่สุด",
    'regftr.earnings.title': "รายได้",
    'regftr.earnings.subtitle': "บริหารและติดตามรายได้และข้อมูลการจ่ายเงินของคุณ",
    'regftr.stats.title': "สถิติ",
    'regftr.stats.subtitle': "เข้าถึงแดชบอร์ดที่มีข้อมูลแบบสอบถามและรายละเอียดผู้ใช้ของคุณทั้งหมด",

    'contextual_help.sms': "คุณจะได้รับการแจ้งเตือน SMS เพื่อเปิดแบบสำรวจขนาดเล็ก คุณจะสามารถเข้าถึงแบบสำรวจได้เร็วขึ้นและรับรางวัลได้มากขึ้นเมื่อดำเนินการผ่านทาง SMS ข้อมูลของคุณได้รับการเก็บรักษาอย่างเป็นส่วนตัวและใช้เพื่อการเชิญเข้าร่วมแบบสำรวจเท่านั้น",
    'contextual_help.specialty': "โปรดแจ้งเฉพาะความเชี่ยวชาญพิเศษที่เชื่อมโยงกับ NPI ของคุณ ที่คุณได้รับการฝึกอบรมเฉพาะในด้านนั้น หรือสาขาการแพทย์ที่อยู่ในสาขาพิเศษหลักของคุณ หากคุณต้องการทำการเปลี่ยนแปลงความเชี่ยวชาญพิเศษของคุณในอนาคต โปรดติดต่อ support@incrowdnow.com",
    // USER
    'user(s)': "ผู้ใช้ |||| ผู้ใช้",
    'user.login': "ลงชื่อเข้าสู่ระบบ",
    'user.logout': "ลงชื่อออกจากระบบ",
    'user.register': "ลงทะเบียน",
    'user.invitations': "การเชิญชวน",
    'user.email': "อีเมล",
    'user.pass_word': "รหัสผ่าน",
    'user.mobile': "โทรศัพท์มือถือ",
    'user.mobile.hint': "โปรดใส่รหัสประเทศ (+%{phoneCode} สำหรับ %{countryName})",
    'user.title': "คำนำหน้าชื่อ",
    'user.title_with_example': "คำนำหน้าชื่อ (เช่น ดร., นาง, นาย)",
    'user.first_name': "ชื่อจริง",
    'user.last_name': "นามสกุล",
    'user.middle_name': "ชื่อกลาง",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "ผู้ใช้",
    'user.anonymous_admin': "ผู้ใช้เป็นผู้ดูแล",
    'user.dashboard': "แดชบอร์ด",
    'user.profile': "ประวัติ",
    'user.profile.picture.upload': "อัปโหลดรูปประวัติ",
    'user.profile.picture.change': "เปลี่ยน",
    'user.primary_lang': "ภาษาหลัก",
    'user.primary_lang?': "ภาษาหลักของคุณคือภาษาอะไร?",
    'user.survey_langs?': "คุณสามารถพูดภาษาอะไรได้อย่างคล่องแคล่ว?",
    'user.notify_email': "แจ้งเตือนโดยอีเมล",
    'user.notify_mobile': "แจ้งเตือนโดยโทรศัพท์มือถือ",
    'user.contact_support': "ติดต่อฝ่ายสนับสนุน",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "โปรด <ติดต่อเรา>",
    'user.profession': "อาชีพ",
    'user.profession?': "อาชีพของคุณคืออะไร?",
    'user.join_now': "เข้าร่วมตอนนี้",
    'user.welcome_back': "ยินดีต้อนรับกลับ!",
    'user.not_a_member?': "ยังไม่ได้เป็นสมาชิก?",
    'user.accept_terms': "ยอมรับข้อกำหนด",
    'user.accept_terms.yes': "ฉันยอมรับ <ข้อกำหนดและเงื่อนไข>",
    'user.remember_me': "จดจำฉันบนอุปกรณ์นี้",
    'user.time_zone': "เขตเวลา",
    'user.payment.policy': "ทุกครั้งที่รางวัลของคุณถึง %{currency}25 คุณจะได้รับการแจ้งเตือนและสามารถเลือกตัวเลือกการชำระเงินของเราผ่านทางโปรไฟล์ InCrowd ของคุณ มีคำถาม? ติดต่อเราผ่านทางหน้าต่างแชทด้านล่าง",
    'user.country.live_work?': "คุณอยู่ประเทศใดและทำงานอะไร?",
    // FORMS
    'form.button.back': "ย้อนกลับ",
    'form.button.next': "ถัดไป",
    'form.button.cancel': "ยกเลิก",
    'form.button.submit': "ส่ง",
    'form.button.continue': "ดำเนินการต่อ",
    'form.button.close': "ปิด",
    'form.button.go!': "ไปเลย!",
    'form.button.complete!': "ทำให้เสร็จตอนนี้!",
    'form.button.update': "อัปเดต",
    'form.button.finish': "สิ้นสุด",
    'form.button.search': "ค้นหา",
    'form.button.end': "สิ้นสุด",
    'form.search.no_matches': "ไม่พบรายการที่ตรงกัน",
    'form.confirm_email': "ยืนยันอีเมล",
    'form.confirm_pass_word': "ยืนยันรหัสผ่าน",
    'form.required_fields': "เขตข้อมูลที่ต้องกรอก",
    'form.nothing_selected': "ไม่ได้เลือกรายการใด",
    'form.confirm_field': "ยืนยัน %{formFieldLabel}",
    'form.choice.n/a': "ไม่ได้ระบุไว้",
    'form.choice.yes': "ใช่",
    'form.choice.no': "ไม่",
    'form.choice.blank_for_all': "เว้นว่างเพื่อเลือกทั้งหมด",
    'form.choices.select_all': "เลือกทั้งหมด",
    'form.choices.deselect_all': "ยกเลิกการเลือกทั้งหมด",
    'form.field.private': "เขตข้อมูลส่วนตัว",

    // USER ERRORS
    'user.error.dup_email': "ผู้ใช้อีกท่านหนึ่งได้ลงทะเบียนด้วยที่อยู่อีเมลที่ให้มาแล้ว <เข้าสู่ระบบแทนหรือไม่?>",
    'user.error.dup_sms': "ผู้ใช้รายอื่นลงทะเบียนด้วยหมายเลขโทรศัพท์มือถือที่ให้แล้ว",
  }
})
